import { render, staticRenderFns } from "./creatStep1.vue?vue&type=template&id=5b049eb9&"
import script from "./creatStep1.vue?vue&type=script&lang=js&"
export * from "./creatStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports